
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
export const fetchWithRetry = async ({ url, options = {}, MAX_RETRIES = 5, RETRIES = 1 }) => {
    try {
        const res = await fetch(url, options)
        if (!res.ok) throw new Error('Network error.')

        return await res.json();
    } catch (err) {
        if (MAX_RETRIES === 0) {
            console.log(`Failed to fetch.`, err)
            throw err
        }

        console.log('Failed to fetch data... Retrying.', err)
        await sleep(RETRIES * 2000)
        return fetchWithRetry({ url, MAX_RETRIES: MAX_RETRIES - 1, RETRIES: RETRIES + 1 })
    }
}
